import React, { useState } from "react";
import {
  Home,
  Bell,
  Database,
  BookOpen,
  FolderKanban,
  Shield,
  Settings,
  ChevronRight,
  PanelLeftDashed,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Container } from "@mui/system";
import { Box, Divider, IconButton, MenuList, Typography } from "@mui/material";
import { MenuInput, MenuItem } from "./new/ProjectHeader";
import { Logout } from "@mui/icons-material";
import ManualModal from "./new/ManualModal";

interface SidebarProps {
  activeMenu: string;
  setActiveMenu: (menu: string) => void;
  pinned: boolean;
}
const menuItems = [
  { id: "dashboard", label: "대시보드", icon: Home },
  { id: "notices", label: "공지사항", icon: Bell },
  // { id: "dataset", label: "데이터셋", icon: Database },
  // { id: "training", label: "학습", icon: BookOpen, isMain: true },
  { id: "projects", label: "프로젝트", icon: FolderKanban, isMain: true },
  { id: "inspection", label: "검사관리", icon: Shield },
  { id: "status", label: "검사현황", icon: Shield },
];

export default function Sidebar({ activeMenu, setActiveMenu, pinned }: SidebarProps) {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [openManual, setOpenManual] = useState(false);

  const handleSettingsClick = () => {
    navigate("/main/setting/user");
  };

  const handleLogout = () => {
    const access_token = localStorage.getItem("access_token");
    const refresh_token = localStorage.getItem("refresh_token");
    if (access_token) {
      localStorage.removeItem("access_token");
    }
    if (refresh_token) {
      localStorage.removeItem("refresh_token");
    }
    localStorage.removeItem("userInfo");
    navigate("/login");
  };

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
        borderRadius: "0 0 12px 12px",
        border: "0.5px solid",
        borderColor: "grey.200",
        borderTop: "none",
        minWidth: 220,
        overflow: "hidden",
        "@keyframes slideDown": {
          from: {
            opacity: 0,
            transform: "translateY(-6px)",
          },
          to: {
            opacity: 1,
            transform: "translateY(0)",
          },
        },
        animation: "slideDown 0.18s ease-out forwards",
      }}
    >
      <MenuList sx={{ py: 0.5 }}>
        {menuItems.map((item, index) => (
          <MenuItem key={index} onClick={() => navigate(`/main/${item.id}`)}>
            {item.label}
          </MenuItem>
        ))}

        <Divider sx={{ my: 0.5 }} />

        <Box sx={{ px: 1, py: 0.5 }}>
          <MenuInput value={searchText} onChange={(e) => setSearchText(e.target.value)} placeholder="전체 검색..." />
        </Box>

        <Divider sx={{ my: 0.5 }} />
        <Box sx={{ px: 1, py: 0.75 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              px: 1.5,
              py: 1,
              borderRadius: 1,
              borderColor: "blue.100",
              bgcolor: "grey.50",
            }}
          >
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                background: "linear-gradient(135deg, #60a5fa, #a78bfa)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#fff" }}>U</Typography>
            </Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography sx={{ fontSize: 13, fontWeight: 500 }} noWrap>
                사용자
              </Typography>
              <Typography sx={{ fontSize: 11, color: "text.secondary" }} noWrap>
                관리자
              </Typography>
            </Box>
            <Box sx={{ display: "flex", gap: 0.5, opacity: 0.7 }}>
              <IconButton size="small" onClick={handleSettingsClick} sx={{ color: "text.secondary" }}>
                <Settings fontSize="small" />
              </IconButton>
              <IconButton size="small" onClick={handleLogout} sx={{ color: "text.secondary" }}>
                <Logout fontSize="small" />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </MenuList>
      <ManualModal open={openManual} onClose={() => setOpenManual(false)} />
    </Box>
  );
}
